import { Fragment, useContext, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { StateContext } from "../../context/StateContext";

export default function AppModal() {
    const [isOpen, setIsOpen] = useState(true);
    const { state, setState } = useContext(StateContext);

    useEffect(() => {
        if (state.success || state.error) setIsOpen(true);
    }, [state.success, state.error]);

    console.log(state);
    return (
        <>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog
                    as="div"
                    className="fixed inset-0 z-10 overflow-y-auto"
                    onClose={() => setState({ ...state, success: false })}
                >
                    <div className="min-h-screen px-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Dialog.Overlay className="fixed inset-0 opacity-50" />
                        </Transition.Child>

                        {/* This element is to trick the browser into centering the modal contents. */}
                        <span
                            className="inline-block h-screen align-middle"
                            aria-hidden="true"
                        >
                            &#8203;
                        </span>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-center align-middle transition-all transform shadow-xl rounded-2xl bg-blue text-white p-10">
                                <Dialog.Title
                                    as="h3"
                                    className="text-2.5xl sm:text-3.5xl font-medium leading-6 text-gray-900"
                                >
                                    {state.success
                                        ? " Thank you!"
                                        : state.error && "Error!"}
                                </Dialog.Title>
                                <div className="mt-2">
                                    <p className="text-base text-gray-500 my-8">
                                        {state.success
                                            ? "Your information has been successfully submitted. We'll be in touch."
                                            : state.error &&
                                              "Oops, something went wrong. Please try again later."}
                                    </p>
                                </div>

                                <div className="mt-4">
                                    <button
                                        type="button"
                                        className="inline-flex justify-center px-4 py-2 text-sm font-medium text-blue-900 bg-blue-100 border border-transparent rounded-md hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                                        onClick={() => {
                                            setIsOpen(false);
                                            setState({
                                                ...state,
                                                loading: false,
                                                error: false,
                                            });
                                        }}
                                    >
                                        Got it, thanks!
                                    </button>
                                </div>
                            </div>
                        </Transition.Child>
                    </div>
                </Dialog>
            </Transition>
        </>
    );
}
